import { default as dashboard } from './dashboard/routes'
import { default as auth } from './auth/routes'
import { default as website } from './website/routes'
import { default as configuracoes } from './configuracoes/routes'
import { default as policiacivil } from './policia-civil/routes'
import callcenter from './callcenter/routes'
import relatorios from './relatorios/routes'
import solicitacoesRemocao from './solicitacao-remocao/routes'
import ChatAdmin from './chat/components/ChatAdmin.vue'

export default [
  ...auth,
  ...dashboard,
  ...website,
  ...configuracoes,
  ...callcenter,
  ...relatorios,
  ...policiacivil,
  ...solicitacoesRemocao,
  {
    path: '/admin/chat',
    component: ChatAdmin,
    name: 'ChatAdmin'
  }
]



// WEBPACK FOOTER //
// ./src/app/routes.js